export default __webpack_public_path__ + "static/media/fasad9.a8a20b72.jpeg";